<script setup lang="ts">
import { useCredenzaContext } from './credenzaContext'

const { isMobile } = useCredenzaContext()

const classList = computed(() =>
  twMerge(
    cva('min-h-0 flex-1 overflow-y-auto scrollbar-hidden', {
      variants: {
        viewport: {
          mobile: 'px-4',
          desktop: 'px-6',
        },
      },
    })({ viewport: isMobile.value ? 'mobile' : 'desktop' }),
  ),
)
</script>

<template>
  <div :class="classList">
    <slot />
  </div>
</template>
